import {
    DOWNLOAD_RESULTS_PDF_FILE_REQUEST,
    downloadResultsPdfFileSuccess,
    downloadResultsPdfFileFailure,
} from 'Redux/Action';
import { ofType }      from 'redux-observable';
import { from, of, catchError } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';

export function downloadResultsPdfFileEpic(action$, store$, { ResultRepository }) {
    return action$.pipe(
        ofType(DOWNLOAD_RESULTS_PDF_FILE_REQUEST),
        mergeMap(action => {
            const { module, year } = action.payload;

            return from(ResultRepository.downloadBulkPdfFile({ module, year })).pipe(
                mergeMap(({ file, fileName }) => {
                  ResultRepository.downloadFile('application/pdf')({ content: file , filename: fileName });
                  return from([
                      downloadResultsPdfFileSuccess(),
                  ]);
                }),
                catchError(error => of(downloadResultsPdfFileFailure(error))),
            );
        }),
    );
}
